export default __webpack_public_path__ + "static/media/icon-pagination-ellipsis.1f72f262.svg";